import { useMutation, useQueryClient } from "react-query";

import { CombinationRulePutSchema } from "~/entity/CombinationRules/model/schema";

import { useCombinationRules } from "./useCombinationRules";
import { COMBINATION_RULES_QUERY_KEY } from "./useGetCombinationRules";

interface MutateOptions {
  onSuccess?: (data?: any) => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  id: number | string;
  data: CombinationRulePutSchema;
  options?: MutateOptions;
}

export const useUpdateCombinationRule = (
  queryKey: string | any[] = COMBINATION_RULES_QUERY_KEY,
) => {
  const { rulePut } = useCombinationRules();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      const result = await rulePut(props.id, props.data);
      if (result.data) {
        return result.data;
      } else {
        throw new Error("Не удалось обновить правило совмещения");
      }
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.(data);
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
    onSettled: () => {
      queryClient.invalidateQueries(queryKey);
    },
  });

  const update = (
    id: number | string,
    data: CombinationRulePutSchema,
    options?: MutateOptions,
  ) => {
    mutation.mutate({ id, data, options });
  };

  return { update, isLoading: mutation.isLoading };
};
